import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/messaging/constants';
import { messagingQueryKeys } from '@/modules/messaging/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface DeleteDraftMessagesParams {
  messageIds: string[];
}

export const useDeleteDraftMessagesMutation = () => {
  return useMutation({
    mutationFn: (body: DeleteDraftMessagesParams) =>
      fetchClient.DELETE(endpoints.messages, {
        body,
      }),
    onSettled: () => {
      invalidateQuery(messagingQueryKeys.messages(['Draft']))();
      invalidateQuery(messagingQueryKeys.threads())();
    },
  });
};
